import type { ToastType, Toast } from '@/types/components/toast';

class ToastService {
    private static instance: ToastService;
    private toastHandler: ((toast: Omit<Toast, 'id'>) => void) | null = null;

    private constructor() {}

    public static getInstance(): ToastService {
        if (!ToastService.instance) {
            ToastService.instance = new ToastService();
        }
        return ToastService.instance;
    }

    // Register the toast handler from ToastProvider
    public registerHandler(handler: (toast: Omit<Toast, 'id'>) => void): void {
        this.toastHandler = handler;
    }

    // Generic toast showing method
    public show(type: ToastType, title: string, message?: string, duration: number = 5000): void {
        if (this.toastHandler) {
            this.toastHandler({ type, title, message: message || '', duration });
        } else {
            console.warn('Toast handler not registered. Make sure ToastProvider is mounted in your app.');
        }
    }

    // Convenience methods for different toast types
    public success(title: string, message?: string, duration?: number): void {
        this.show('success', title, message, duration);
    }

    public error(title: string, message?: string, duration?: number): void {
        this.show('error', title, message, duration);
    }

    public warning(title: string, message?: string, duration?: number): void {
        this.show('warning', title, message, duration);
    }

    public info(title: string, message?: string, duration?: number): void {
        this.show('info', title, message, duration);
    }
}

// Export a singleton instance
export const toastService = ToastService.getInstance();